import React, { useState, createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

// Create context for mobile menu control
const MobileMenuContext = createContext();

export const useMobileMenu = () => {
    const context = useContext(MobileMenuContext);
    if (!context) {
        return { openMobileMenu: () => {}, closeMobileMenu: () => {} };
    }
    return context;
};

const DashboardLayout = ({ children, activeSection = null, onSectionChange = null, counts = {} }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    // Determine active section from current path if not provided
    const getActiveSection = () => {
        if (activeSection) return activeSection;
        if (location.pathname === '/wallet') return 'wallet';
        if (location.pathname === '/profile') return 'profile';
        if (location.pathname === '/docs/api') return 'docs';
        if (location.pathname.startsWith('/services/')) return 'services';
        return 'services';
    };

    const handleSectionChange = (section) => {
        if (onSectionChange) {
            onSectionChange(section);
        }
        setMobileOpen(false); // Close mobile drawer on selection
    };

    const mobileMenuValue = {
        openMobileMenu: () => setMobileOpen(true),
        closeMobileMenu: () => setMobileOpen(false),
    };

    return (
        <MobileMenuContext.Provider value={mobileMenuValue}>
            <div className="min-h-screen bg-root flex">
                <Sidebar
                    activeSection={getActiveSection()}
                    onSectionChange={handleSectionChange}
                    collapsed={collapsed}
                    mobileOpen={mobileOpen}
                    onCloseMobile={() => setMobileOpen(false)}
                    onToggleCollapse={() => setCollapsed(!collapsed)}
                    onOpenDocs={() => window.open('/docs', '_blank')}
                    counts={counts}
                />

                <main
                    className={`flex-1 transition-all duration-300 pt-4 pb-12 px-4 md:px-6 lg:px-10 min-h-[calc(100vh-80px)] ${collapsed ? 'md:ml-[68px]' : 'md:ml-[240px]'}`}
                >
                    <div className="max-w-6xl mx-auto">
                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setMobileOpen(true)}
                            className="md:hidden mb-4 flex items-center gap-2 px-4 py-2 bg-card border border-inner rounded-lg hover:border-indigo/50 transition"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            <span className="text-sm font-medium">Menu</span>
                        </button>

                        {children}
                    </div>
                </main>
            </div>
        </MobileMenuContext.Provider>
    );
};

export default DashboardLayout;
